import { HttpBackendService } from "./http-backend.service";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { PhotoType } from "../models/photoDataPhotoType";


@Injectable()
export class FileStorageService {

  constructor(
    private _http: HttpBackendService
  ) { }


  public getPhotoFile(fileId: string, type: PhotoType): Observable<Blob> {
    return this._http.get("/api/file/?fileId=" + fileId + "&type=" + type, null, true, true)
      .map(resp => {
        return resp.blob();
      });
  }

  public getPlannedServicePhotoAchive(plannedServiceId: number): Observable<Blob> {
    return this._http.get("/api/file/archive/plannedservice/" + plannedServiceId, null, true, true)
      .map(resp => {
        return resp.blob();
      });
  }

  public getCallPhotoAchive(callId: number): Observable<Blob> {
    return this._http.get("/api/file/archive/call/" + callId, null, true, true)
      .map(resp => {
        return resp.blob();
      });

  }

  public getSurveyFieldPhotoArchive(taskId: number, sectionNumber: number, fieldNumber: number, tupleNumber?: number): Observable<Blob> {
    let url = `/api/file/archive/taskSurvey/${taskId}/section/${sectionNumber}/field/${fieldNumber}`;

    // Добавить часть URL для tupleNumber, если он определён
    if (tupleNumber != null) {
      url += `?tupleNumber=${tupleNumber}`;
    }

    return this._http.get(url, null, true, true)
      .map(resp => {
        return resp.blob();
      });
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/services/fileStorage.service.ts